import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { lgpdService } from "@/services/lgpdService";

const KEY = ["consents"] as const;

export function useConsents() {
  return useQuery({ queryKey: KEY, queryFn: lgpdService.listConsents });
}

export function useRevokeConsent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (purpose: string) => lgpdService.revokeConsent(purpose),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
